import { siteInfo } from '@/mocks/siteInfo';

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-database-2-line text-xl text-primary-600"></i>
            </div>
            <p className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {(siteInfo.stats.totalArticles / 10000).toFixed(1)}万+
            </p>
            <p className="text-sm text-foreground-500 mt-1">收录番号</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-folder-line text-xl text-accent-600"></i>
            </div>
            <p className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {siteInfo.stats.totalCategories}+
            </p>
            <p className="text-sm text-foreground-500 mt-1">内容分类</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
              <i className="ri-team-line text-xl text-secondary-600"></i>
            </div>
            <p className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {(siteInfo.stats.totalActors / 10000).toFixed(1)}万+
            </p>
            <p className="text-sm text-foreground-500 mt-1">收录演员</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-user-heart-line text-xl text-primary-600"></i>
            </div>
            <p className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {(siteInfo.stats.dailyVisitors / 10000).toFixed(1)}万+
            </p>
            <p className="text-sm text-foreground-500 mt-1">日活跃用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}